<template>
  <div>
    <v-card
      flat
    >
      <v-card-title>
        <span style="color: #0074BA">運搬情報</span>&emsp;
        <v-btn
          v-if="canShowEditButton"
          small
          @click="enableDialogButtonClickEvent"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
          &nbsp;編集
        </v-btn>
      </v-card-title>
      <v-spacer />
      <v-card-text>

        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              引渡担当者
            </div>
            <h4>{{ order.deliver_staff || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              登録担当者
            </div>
            <h4>{{ order.register_staff || '-' }}</h4>
            <v-divider />
          </v-col>
        </v-row>

        <!-- 運搬担当者 / 運搬方法 / 車両番号 -->
        <v-row>
          <v-col cols="12" md="3">
            <div class="overline">
              運搬担当者
            </div>
            <h4>{{ order.first_manifest.transport_user_name || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              運搬方法
            </div>
            <h4>{{ order.first_manifest.transportation_name || '-' }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="3">
            <div class="overline">
              車両番号
            </div>
            <h4>{{ order.first_manifest.vehicle_number || '-' }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /運搬担当者 / 運搬方法 / 車両番号 -->
      </v-card-text>
    </v-card>

    <edit-transaction-location-dialog
      :enable-dialog="enableTransportLocationDialog"
      :order-id="order.id"
      :order="order"
      :deliverers="deliverers"
      :registers="registers"
      :transportations="transportations"
      @closeCallback="dialogCloseCallback"
      @registerCallback="dialogRegisterCallBack"
    />
  </div>
</template>

<script>

import EditTransactionLocationDialog from '../dialogs/_EditTransportLocationDialog'
import {mapActions} from "vuex";

export default {
  name: 'OrderTransportBlock',
  components: {
    EditTransactionLocationDialog
  },
  filters: {},
  mixins: [],
  props: {
    /**
     * @typedef order { Object }
     * @param order.emission { Object }
     * @property emission_location { Object }
     * @property collection_report { Object }
     */
    order: {
      type: Object,
      default: () => {},
    },
    canShowEditButton: {
      type: Boolean,
      default: () => false,
    },
    deliverers: {
      type: Array,
      default: () => []
    },
    registers: {
      type: Array,
      default: () => []
    },
    transportations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      enableTransportLocationDialog: false,
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    enableDialogButtonClickEvent () {
      this.enableTransportLocationDialog = true
    },
    /**
     * ダイアログを閉じる処理
     */
    dialogCloseCallback () {
      this.enableTransportLocationDialog = false
    },
    /**
     * ダイアログ上での登録処理完了後のコールバック処理
     * ダイアログを閉じ、再取得を行う.
     */
    dialogRegisterCallBack () {
      this.dialogCloseCallback()
      this.$emit('refreshDetail')
    },

  }
}
</script>

<style lang="scss">

table tbody tr {
  cursor: pointer;
}
table tbody tr.v-data-table__selected {
  background: #2196f3 !important;
  color: #fff;
}


</style>
